export const formatPhoneNumber = (phone: string) => {
  const cleanedPhone = phone.replace(/\\s\+/g, '')
  const groups = cleanedPhone.match(/^(7)(\S{3})(\S{3})(\d{4})$/)
  return groups
    ? `${groups[1]} ${groups[2]} ${groups[3]} ${groups[4]}`
    : cleanedPhone
}
